import React, { Fragment } from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useLocation } from 'wouter';

import AdvisorsSettings from './components/AdvisorsSettings';
import GroupsSettings from './components/GroupsSettings';
import getSettingsOptions from './settingsOptions';
import type { SettingsOptions } from '../common/types/general';

const settings: Record<SettingsOptions, React.ReactNode> = {
  advisors: <AdvisorsSettings />,
  groups: <GroupsSettings />,
};

function Settings() {
  const [location] = useLocation();

  const settingsOptions = getSettingsOptions(location);

  return (
    <Stack px={3} py={4} height='100%' overflow='auto scroll'>
      <Typography fontSize='1.5rem'>Einstellungen</Typography>
      <Stack direction='column' px={1} maxWidth='650px' sx={{ marginTop: '2rem' }}>
        {settingsOptions.map((settingsOption) => (
          <Fragment key={settingsOption}>{settings[settingsOption]}</Fragment>
        ))}
      </Stack>
    </Stack>
  );
}

export default Settings;
